module.exports = __webpack_public_path__ + "0274ff18ee34657a78635df666ce02c6.pdf";